import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import RadioCard from "../../RadioCard";
import ValidatedField from "../../form/ValidatedField";
import {
  RevisorsSectionProps,
  scrollToRefIfNotInView,
} from "../RevisorsErklaering";

export default function RevisorsHandling4(props: RevisorsSectionProps) {
  const { locked, isCompleteHelpers, formikProps, refs, texts } = props;
  const { revisors_handling_4 } = texts;
  const { values, errors, touched } = formikProps;
  return (
    <AccordionItem value="Handling4">
      <AccordionHeader
        sectionStarted={
          !!values.revisors_handling_4_question ||
          !!values.revisors_handling_4_revisionsbesoeg_dato
        }
        sectionComplete={isCompleteHelpers.revisors_handling_4_complete}
        ref={refs.handling_4_ref}
        onClick={() => {
          scrollToRefIfNotInView(refs.handling_3_ref);
        }}
      >
        {revisors_handling_4.title}
      </AccordionHeader>
      <AccordionBody>
        <fieldset disabled={locked}>
          <div className="h5 fw-normal mb-4 lh-base">
            <p>{revisors_handling_4.description}</p>
            <div className="row align-items-center">
              <label
                className="form-label col-auto"
                htmlFor={
                  revisors_handling_4.revisors_handling_4_revisionsbesoeg_dato
                    .id
                }
              >
                {
                  revisors_handling_4.revisors_handling_4_revisionsbesoeg_dato
                    .label
                }
              </label>
              <div className="col-auto w-auto position-relative">
                <ValidatedField
                  touched={touched.revisors_handling_4_revisionsbesoeg_dato}
                  error={errors.revisors_handling_4_revisionsbesoeg_dato}
                  name={
                    revisors_handling_4.revisors_handling_4_revisionsbesoeg_dato
                      .id
                  }
                  id={
                    revisors_handling_4.revisors_handling_4_revisionsbesoeg_dato
                      .id
                  }
                  type="date"
                />
              </div>
            </div>
          </div>
          <div className="vstack gap-3" role="group">
            <RadioCard
              name={revisors_handling_4.revisors_handling_4_question.id}
              id={
                revisors_handling_4.revisors_handling_4_question
                  .revisors_handling_4_question_alt_1.value
              }
              value={
                revisors_handling_4.revisors_handling_4_question
                  .revisors_handling_4_question_alt_1.value
              }
              text={
                revisors_handling_4.revisors_handling_4_question
                  .revisors_handling_4_question_alt_1.label
              }
            ></RadioCard>
            <RadioCard
              name={revisors_handling_4.revisors_handling_4_question.id}
              id={
                revisors_handling_4.revisors_handling_4_question
                  .revisors_handling_4_question_alt_2.value
              }
              value={
                revisors_handling_4.revisors_handling_4_question
                  .revisors_handling_4_question_alt_2.value
              }
              text={
                revisors_handling_4.revisors_handling_4_question
                  .revisors_handling_4_question_alt_2.label
              }
            >
              <label
                htmlFor={
                  revisors_handling_4.revisors_handling_4_alt_2_uddybning.id
                }
                className="mb-2"
              >
                Uddybning{" "}
                <span className="text-muted">
                  (forklaring på at bogholderisystemet ikke kunne vise de
                  enkelte mellemværender og/eller det samlede klienttilsvar)
                </span>
                :
              </label>
              <ValidatedField
                autoComplete="off"
                as="textarea"
                id={revisors_handling_4.revisors_handling_4_alt_2_uddybning.id}
                name={
                  revisors_handling_4.revisors_handling_4_alt_2_uddybning.id
                }
                placeholder="Uddybning"
                rows={2}
                touched={touched.revisors_handling_4_alt_2_uddybning}
                error={errors.revisors_handling_4_alt_2_uddybning}
              />
            </RadioCard>
          </div>
        </fieldset>
      </AccordionBody>
    </AccordionItem>
  );
}
